import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Seo from './components/Seo';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import HomeEn from './pages/HomeEn';
import AboutUsPage from './pages/AboutUsPage';
import AboutUsPageEn from './pages/AboutUsPageEn';
import WhatWeDoPage from './pages/WhatWeDoPage';
import AssetsPage from './pages/AssetsPage';
import AssetsPageEn from './pages/AssetsPageEn';
import TeamPage from './pages/TeamPage';
import TeamMemberPage from './pages/TeamMemberPage';
import MediaPage from './pages/MediaPage';
import MediaPageEn from './pages/MediaPageEn';
import ContactPage from './pages/ContactPage';
import ContactPageEn from './pages/ContactPageEn';
import ManagementPage from './pages/ManagementPage';
import ManagementPageEn from './pages/ManagementPageEn';
import RealEstatePage from './pages/RealEstatePage';
import RealEstatePageEn from './pages/RealEstatePageEn';
import AvisoLegalPage from './pages/AvisoLegalPage';
import PoliticaPrivacidadPage from './pages/PoliticaPrivacidadPage';
import PoliticaCookiesPage from './pages/PoliticaCookiesPage';
import LegalNoticePage from './pages/LegalNoticePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import NotFoundPage from './pages/NotFoundPage';

function AppContent() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const legalPages = ['/aviso-legal', '/politica-de-privacidad', '/politica-de-cookies', '/en/legal-notice', '/en/privacy-policy', '/en/cookie-policy'];
  // Pages that open on a light background need the solid navigation bar, or the
  // white logo and links sit on white.
  const needsSolidNav = legalPages.includes(location.pathname)
    || location.pathname.startsWith('/equipo/');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Seo />
      <Navigation scrolled={scrolled || needsSolidNav} />
        <Routes>
          {/* Spanish Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/grupo" element={<AboutUsPage />} />
          <Route path="/que-hacemos" element={<WhatWeDoPage />} />
          <Route path="/gestion" element={<ManagementPage />} />
          <Route path="/inmobiliaria" element={<RealEstatePage />} />
          <Route path="/activos" element={<AssetsPage />} />
          <Route path="/equipo" element={<TeamPage />} />
          <Route path="/equipo/:slug" element={<TeamMemberPage />} />
          <Route path="/medios" element={<MediaPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          
          {/* English Routes */}
          <Route path="/en" element={<HomeEn />} />
          <Route path="/en/grupo" element={<AboutUsPageEn />} />
          <Route path="/en/gestion" element={<ManagementPageEn />} />
          <Route path="/en/inmobiliaria" element={<RealEstatePageEn />} />
          <Route path="/en/activos" element={<AssetsPageEn />} />
          <Route path="/en/equipo" element={<TeamPage />} />
          <Route path="/en/medios" element={<MediaPageEn />} />
          <Route path="/en/contacto" element={<ContactPageEn />} />

          {/* Legal Pages */}
          <Route path="/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/politica-de-privacidad" element={<PoliticaPrivacidadPage />} />
          <Route path="/politica-de-cookies" element={<PoliticaCookiesPage />} />
          <Route path="/en/legal-notice" element={<LegalNoticePage />} />
          <Route path="/en/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/en/cookie-policy" element={<CookiePolicyPage />} />

          {/* Catch-all 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
  );
}

function App() {
  return (
    <Router>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </Router>
  );
}

export default App;
